import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { LanguageModel } from 'projects/core/src/lib/models/language.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-language-basedata',
  templateUrl: './language-basedata.component.html',
  styleUrls: ['./language-basedata.component.scss']
})
export class LanguageBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() language: LanguageModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public form = this.fb.group({
    key: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.language !== null) {
      if (this.auth.hasRight('admin.language.delete')) {
        this.items.push({
          label: this.transloco.translate('common.labels.delete'),
          icon: 'pi pi-trash',
          styleClass: 'danger-button',
          disabled: (!this.language.deletable),
          command: () => {
            this.onDelete();
          }
        });
      }
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('languages', this.language.id, this.form.value).subscribe({
        next: (result: any) => {
          this.language.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.language.name }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.language.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.language.name }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('languages', this.language.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.language.name }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/languages']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.language !== null) {
      this.form.patchValue({
        key: this.language.key,
        name: this.language.name,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
